import React, {useState} from 'react';
import { useField } from 'formik';
import { FormControl, InputLabel, OutlinedInput, FormHelperText, InputAdornment, IconButton } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { passwordRequirements, validationMessage } from '../../configure/validationConfig';
import { useTheme } from '@mui/material/styles';


const PasswordRequirements = ({ value }) => {
    const theme = useTheme();
    return (
      <ul style={{marginLeft: -24}}>
        {passwordRequirements.map(({ test, message }, index) => (
          <li key={index} style={{ color: test.test(value) ? theme.palette.success.main : '#535F70' }}>
            {message}
          </li>
        ))}
      </ul>
    );
};

const CustomLabelInput = ({  
    label,
    name,
    placeholder,
    type="text",
    disabled = false,
    showPasswordToggle = false,
    showRules = false,
    isError= false,
    required=false,
    maxLength=32
    }) => {
    const [field, meta, { setValue, setTouched }] = useField(name);
    const [showPassword, setShowPassword] = useState(type === 'password' ? false : true);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };


    return (
        <FormControl required={required}>
            <InputLabel
                error={Boolean(meta.touched && meta.error)}
                shrink={true}
                htmlFor={name}
            >
                {label}
            </InputLabel>
            <OutlinedInput
                id={name}
                type={showPasswordToggle && type === 'password' ? (showPassword ? "text" : "password") : type}
                value={field.value}
                notched={true}
                name={name}
                onBlur={() => setTouched(true)}
                onChange={(e) => { setValue(e.target.value)}}
                disabled={disabled}
                inputProps={{maxLength: maxLength + 1}}
                placeholder={placeholder}
                fullWidth
                error={Boolean(meta.touched && meta.error)}
                endAdornment={
                    <InputAdornment position="end">
                        { Boolean(meta.touched && meta.error) && field.value.length === 0 ? (
                            <ErrorIcon sx={{ color: "#BA1A1A" }} />
                          ) : (showPasswordToggle && type === 'password' &&
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              edge="end"
                              size="large"
                            >
                              {showPassword ? (
                                <EyeInvisibleOutlined />
                              ) : (
                                <EyeOutlined />
                              )}
                            </IconButton>
                          )}
                    </InputAdornment>
                }
            />
            { meta.touched && ( meta.error || isError ) && (
                <>
                    <FormHelperText
                        error
                        id={`standard-weight-helper-text-${name}`}
                        style={{marginBottom: "-10px"}}
                    >
                      { meta.error ? (showRules ? validationMessage.ENTER_PASSWORD : meta.error) : validationMessage.MISMATCH_INVITE_AND_EMAIL}
                    </FormHelperText>
                    {showRules ? <PasswordRequirements value={field.value} /> : <></> }
                </>
            )}

            <style jsx>
              {/* disabled the eye in microsoft edge */}
              {`
                input::-ms-reveal,
                input::-ms-clear { display: none; }
              `}
            </style>
        </FormControl>
    );
}

export default CustomLabelInput;